import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import DefaultModal from "../DefaultModal";
import { dispatchCusEvent } from "../../../utils/utils";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener";
import useRequireVerify from "../../../hooks/useRequireVerify";
import LoaderContainer from "../../mui/loader_container/LoaderContainer";

const PromoCodeContent = lazy(() => import("./PromoCodeContent"));

export default function PromoCodeModal({ isOpen, closeModal }) {
  const { lockPromocode } = useRequireVerify();

  const [code, setCode] = useState("");
  const [successData, setSuccessData] = useState(false);

  const captchaRef = useRef();

  useEffect(() => {
    if (isOpen) {
      if (lockPromocode) {
        dispatchCusEvent(ENUM_COMMON_EVENT.emailNotConfirmed);
        closeModal();
        return;
      }
      return;
    }
    setSuccessData(false);
    setCode("");
    captchaRef.current?.reset();
  }, [isOpen]);

  const transparentClass = successData ? "" : "transparent";

  return (
    <DefaultModal
      miniModal
      isOpen={isOpen}
      closeModal={closeModal}
      classModal={`promo-code ${transparentClass}`}>
      {isOpen && (
        <Suspense fallback={<LoaderContainer loader center />}>
          <PromoCodeContent
            code={code}
            captchaRef={captchaRef}
            successData={successData}
            setCode={setCode}
            setSuccessData={setSuccessData}
            closeModal={closeModal}
          />
        </Suspense>
      )}
    </DefaultModal>
  );
}
